import { setLocalStorageLoginToken } from "src/utils/localStorageWorker";
import * as R from "../../../requests/impersonation/requestCreators";
import { FlowioThunkCreator } from "../../types";
import * as AC from "../actionCreators";
import * as S from "../selectors";

type Params = {
  userId: number;
};

type ThunkCreator = FlowioThunkCreator<Params>;

export const impersonate: ThunkCreator =
  ({ userId }) =>
  (dispatch, getState) =>
    Promise.resolve().then(async () => {
      const isSubmitting = S.getIsImpersonationSubmitting(getState());
      if (isSubmitting) return;

      dispatch(AC.startImpersonationRequest({ userId }));

      try {
        const response = await R.impersonate(userId);

        // todo: Authorization
        setLocalStorageLoginToken(response.data);

        dispatch(AC.startImpersonationSuccess({ userId }));
      } catch (e) {
        dispatch(AC.startImpersonationError({ userId }));
      }
    });

export type ImpersonateParams = Params;
export type Impersonate = ThunkCreator;
